import styled from '@emotion/styled'

export const Separator = styled.div`
  border-bottom: 1px solid #E7E7E7;
  margin-top: 0.75rem;
`
